import React, { ReactNode } from 'react';
import { LeftOutlined } from '@ant-design/icons';
import { StyledIconWrapper } from './styles';
import { H1 } from '../typography/styles';
import IconButton from '../icon-button/IconButton';
import Typography from 'antd/lib/typography/Typography';

interface Props {
    title: string;
    subtitle?: string;
    icon?: ReactNode;
    additionalContent?: ReactNode;
    showBackButton?: boolean;
    sidebar?: ReactNode;
    onBackButtonClick?: () => void;
}

const PageHeader: React.FC<Props> = ({
    showBackButton = false,
    sidebar = null,
    additionalContent = null,
    title,
    subtitle,
    icon,
    onBackButtonClick,
}) => {
    const baseElement = (
        <div style={{ display: 'flex' }}>
            <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                {icon && <StyledIconWrapper>{icon}</StyledIconWrapper>}
                <div style={{ display: 'flex', alignItems: 'flex-start', gap: 8 }}>
                    {showBackButton && (
                        <span style={{ paddingTop: 5 }}>
                            <IconButton tooltipText="Back" icon={<LeftOutlined />} onClick={onBackButtonClick} />
                        </span>
                    )}
                    <div>
                        <H1>{title}</H1>
                        {subtitle && <Typography>{subtitle}</Typography>}
                    </div>
                </div>
            </div>
            {additionalContent}
        </div>
    );

    if (sidebar) {
        return (
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                }}
            >
                {baseElement}
                {sidebar}
            </div>
        );
    }

    return baseElement;
};

export default PageHeader;
